module.exports = __webpack_public_path__ + "img/thebigblue.1a694613.png";